import { App } from 'Features/app/App'
import { createRoot } from 'react-dom/client'
import {
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser'
// `msalInstance` is constructed in its own module so route loaders that fire
// during webpack module evaluation (before this file's top-level statements
// run) still see a defined singleton. Re-exported so existing
// `import { msalInstance } from '../../'` consumers keep working.
import { msalInstance } from 'Features/Auth/msal-instance'
export { msalInstance }

const handleMsalRedirectPromise = async () => {
  try {
    sessionStorage.setItem('authRedirectInProgress', 'true')

    const response = await msalInstance.handleRedirectPromise()

    if (response) {
      sessionStorage.removeItem('authRedirectInProgress')
    }

    return response
  } catch (error) {
    console.error('Error during redirect handling:', error)
    sessionStorage.removeItem('authRedirectInProgress')
    return null
  }
}

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      const account = payload.account
      msalInstance.setActiveAccount(account)
      console.log('Login Success:', account)

      sessionStorage.removeItem('authRedirectInProgress')
    }
  })

  handleMsalRedirectPromise().then(() => {
    const domNode = document.getElementById('root') as HTMLElement
    const root = createRoot(domNode)
    root.render(<App />)
  })
})
